import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import { Validators } from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import data from 'src/assets/states.json';
import { CommonResponseRecords } from 'src/models/commomnModel.model';
import { Vendor } from 'src/models/vendor.model';
import { CommonPagesService } from '../../common-pages.service';
import { responseMessageStatus, ResponseStatus } from '../../enum';
@Component({
  selector: 'app-add-investor-form',
  templateUrl: './add-investor-form.component.html',
  styleUrls: ['./add-investor-form.component.scss'],
  standalone: false,
})
export class AddInvestorFormComponent implements OnInit {
  //#region properties
  listOfStates = data.States;
  isAddingInvestor: boolean = false;
  isVisibleInvestorDrawer = false;
  isAddAddressClicked: boolean = false;
  isInternationalClicked: boolean = false;
  @Input() IsDrawer: boolean = false;
  @Output() investorData = new EventEmitter();
  siteId: string = '';
  //#endregion

  //constructor
  constructor(
    public _cS: CommonService,
    public _fS: FormService,
    private route: ActivatedRoute,
    private _cpS: CommonPagesService
  ) {
    _fS.addInvestorForm_fb();
  }

  //#region functions
  ngOnInit(): void {
    this.siteId = this.route.snapshot.paramMap.get('siteId');
    this.listOfStates = data.States;

    //patch usa to country
    // this._fS.addInvestorForm.patchValue({
    //   country: "USA",
    // });
  }

  //add or update button of drawer clicked
  handleOk() {
    if (this._fS.addInvestorForm.valid) {
      if (!this.isAddAddressClicked) {
        this._fS.addInvestorForm.patchValue({
          streetAddress1: '',
          streetAddress2: '',
          city: '',
          state: '',
          zipCode: '',
          country: '',
        });
      }
      this.isAddingInvestor = true;
      const formValue = this._fS.addInvestorForm.value;
      const investorBody = {
        siteId: this.siteId,
        companyName: formValue.companyName.trim(),
        investorDisplayName:
          formValue.firstName.trim() + ' ' + formValue.lastName.trim(),
        email: formValue.emailAddress,
        phoneNumber: formValue.phoneNumber,
        streetAddress1: formValue.streetAddress1,
        streetAddress2: formValue.streetAddress2,
        city: formValue.city,
        state: formValue.state,
        zipCode: formValue.zipCode,
        country: formValue.country,
        isNonAlc: formValue.isNonAlc,
        isAddLine: this.isInternationalClicked,
      };

      //add or edit user data
      this.addInvestor(investorBody);
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.addInvestorForm);
    }
  }

  //close drawer
  handleCancel(data: any) {
    this.isVisibleInvestorDrawer = false;
    this.investorData.emit({
      hide: this.isVisibleInvestorDrawer,
      data: data,
    });
  }

  addAddressInvestor(event: boolean) {
    this.isAddAddressClicked = event;

    //make street address 1, city, state, zipcode and country required
    if (this.isAddAddressClicked) {
      // this._fS.addInvestorForm.controls["streetAddress1"].setValidators([
      //   Validators.required,
      // ]);
      // this._fS.addInvestorForm.controls["city"].setValidators([
      //   Validators.required,
      // ]);
      // this._fS.addInvestorForm.controls["state"].setValidators([
      //   Validators.required,
      // ]);
      // this._fS.addInvestorForm.controls["zipCode"].setValidators([
      //   Validators.required,
      // ]);
      // this._fS.addInvestorForm.controls["country"].setValidators([
      //   Validators.required,
      // ]);
    } else {
      // this._fS.addInvestorForm.controls["streetAddress1"].clearValidators();
      // this._fS.addInvestorForm.controls["city"].clearValidators();
      // this._fS.addInvestorForm.controls["state"].clearValidators();
      // this._fS.addInvestorForm.controls["zipCode"].clearValidators();
      // this._fS.addInvestorForm.controls["country"].clearValidators();
    }
  }
  addInternationalClicked(event: boolean) {
    this.isInternationalClicked = event;
    if (this.isInternationalClicked) {
      //combine street address 1, street address 2 and city, state, zipcode and country in one temp variable and the patch in street address 1
      //and set street address 2 to empty

      const form = this._fS.addInvestorForm.value;

      const address =
        (form.streetAddress1?.trim() ? form.streetAddress1.trim() + '\n' : '') +
        (form.streetAddress2?.trim() ? form.streetAddress2.trim() + '\n' : '') +
        (form.city?.trim() ? form.city.trim() + ', ' : '') +
        (form.state?.trim() ? form.state.trim() + ' ' : '') +
        (form.zipCode?.trim() ? form.zipCode.trim() + '\n' : '') +
        (form.streetAddress1?.trim() ||
        form.streetAddress2?.trim() ||
        form.city?.trim() ||
        form.state?.trim() ||
        form.zipCode?.trim()
          ? form.country
          : '');

      // set city state zip country validators to empty
      // this._fS.addInvestorForm.controls["city"].clearValidators();
      // this._fS.addInvestorForm.controls["state"].clearValidators();
      // this._fS.addInvestorForm.controls["zipCode"].clearValidators();
      // this._fS.addInvestorForm.controls["country"].clearValidators();
      // this._fS.addInvestorForm.updateValueAndValidity();
      this._fS.addInvestorForm.patchValue({
        streetAddress1: address,
        streetAddress2: '',
        city: '',
        state: '',
        zipCode: '',
        country: '',
      });
    } else {
      //if international clicked is false then split street address 1 by \n and set street address 1, street address 2, city, state, zipcode and country
      // const streetAddress = this._fS.addInvestorForm.value.streetAddress1.split(",");
      // const address = streetAddress[0].split("\n");
      // const stateZip = streetAddress[1].split(" ");
      // const zip = stateZip[1] ? stateZip[1].split("\n")[0] : '';

      // this._fS.addInvestorForm.patchValue({
      //   streetAddress1: address[0] ? address[0] : '',
      //   streetAddress2: address[1] && address[1] != 'USA' ? address[1] : "",
      //   city: address[2] ? address[2] : '',
      //   state: stateZip[0] ? stateZip[0] : '',
      //   zipCode: zip ? zip : '',
      //   country: 'USA',
      // });

      this._fS.addInvestorForm.patchValue({
        streetAddress1: '',
        country: 'USA',
      });
      //set city state zip country validators to required
      // this._fS.addInvestorForm.controls["city"].setValidators([
      //   Validators.required,
      // ]);
      // this._fS.addInvestorForm.controls["state"].setValidators([
      //   Validators.required,
      // ]);
      // this._fS.addInvestorForm.controls["zipCode"].setValidators([
      //   Validators.required,
      // ]);
      // this._fS.addInvestorForm.controls["country"].setValidators([
      //   Validators.required,
      // ]);
      // this._fS.addInvestorForm.updateValueAndValidity();
    }
  }

  //add or update data on buttton click
  addInvestor(investorBody: any) {
    this._cpS
      .addInvestor(investorBody)
      .subscribe((response: CommonResponseRecords<Vendor>) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isAddingInvestor = false;
          this._cS.displayMessage(
            responseMessageStatus.success,
            response.message
          );
          // hide investor drawer
          this.handleCancel(response.result);
        } else {
          this.isAddingInvestor = false;
          this._cS.displayMessage(
            responseMessageStatus.error,
            response.message
          );
        }
      });
  }
  //#endregion
}
